import { SchemaType } from '../type';
export const schema = {
    id: 'project_auth_appids',
    name: get => `授权数据库（${get('appId')}）`,
    type: SchemaType.Indivisible,
};
